import React, { Component } from 'react'
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import trans from "trans"

const {round, floor, ceil} = Math

import {
    css,
    Toggler,
    InputGroup,
    FieldLabel,
    Div,
    Grid,
    GridCell,
    Range,
    Theme,
    Icon,
    Message,
    Select,
    PopupHint,
} from "@bdfx/mergado-ui-kit"

import {Slider} from "@mui/material";

import { ReduxList } from "app/types/app-types";
import { eshopId, projectId } from "app/helpers/api"
import { initForm, updateInputValue as change } from "app/reducers/form"
import { createToast } from "actions";

import {
    Size,
    CollageLayoutType,
    emptyEffects,
    FloodFillPoint,
    Template,
    Gradient,
    BackgroundType,
    SettingsFormType,
    AlternativeTemplate,
    EffectsType
} from "app/types/model-types"

import { RandomProduct } from "shape-edit/types";

import { isJson } from "app/helpers/other";
import { iconDisabledColor } from "./tools-panel";
import EffectsForm from "../forms/effects-form";
import { setActiveGroupId, setActiveShapeId, setActiveView } from 'shape-edit/reducers';

import { ProductImageReflection, ProductImageShadow } from "../forms/shadow-and-reflection";
import SelectGradient from "shape-edit/forms/select-gradient";
import TransparentColor from "shape-edit/forms/transparent-color";
import WatermarkGroupsSelect, { SHOW_MAX_IMAGES } from "watermark-groups/watermark-groups-select";
import { AITemplatType, InpaintingGroupType, RENDERED_TYPE_AUTOWMREMOVE, RENDERED_TYPE_BGREMOVE, RENDERED_TYPE_INPAINTING, RENDERED_TYPE_OUTPAINTING, RENDERED_TYPE_UPSCALE, WatermarkGroupType } from "products/types";

import MultiColorSelect from './multi-color-select'
import MultiGradientSelect from './multi-gradient-select'
import { hexToRgba } from 'app/helpers/colors'
import { selectFormValues } from 'app/reducers/form'
import { UpdateEffectsFunctionType } from 'template-edit/containers/Editor'
import InpaintingGroupSelect from './inpainting-group-select'
import { canBeOutpaintedOver, getFormName, getSelectedAltLevels, getTemplateSize } from 'shape-edit/forms/helpers'
import { NumericInput } from 'shape-edit/forms/fields'
import { debounce, find } from 'lodash'
import { DO_NOT_SAVE_HISTORY } from 'template-edit/sagas/undoRedoHistory'
import { TemplateOrAlternativeTemplateType } from 'template-edit/undoRedoReducers'

interface Props {
    watermarkGroups: ReduxList<WatermarkGroupType[]>
    inpaintingGroups: ReduxList<InpaintingGroupType[]>
    settingsForm: SettingsFormType
    isAlt: boolean
    form: TemplateOrAlternativeTemplateType
    randomProduct: RandomProduct
    change: typeof change
    initForm: typeof initForm
    collageLayoutsForm: CollageLayoutType[]
    setActiveShapeId: typeof setActiveShapeId
    setActiveGroupId: typeof setActiveGroupId
    setActiveView: typeof setActiveView
    updateEffects: UpdateEffectsFunctionType
    setShowAsModal: Function
    updateTemplateFieldValue: Function
    userId: number
    showAsModal: boolean
}

interface State {
    oldSizeBeforeNewFormat: Size
    newFormat: Size
    isLoaded: boolean
    floodFillPoints: FloodFillPoint[]
    newX: number
    newY: number
    newFuzz: number
    validateNow: boolean
    backgroundType: BackgroundType
    showFilters: boolean
    oldFilters: EffectsType
}

const defaultFuzz = 600

class EditEffects extends Component<Props, State> {
    constructor(props) {
        super(props)

        const isShowFilters = !!(props.form.effects?.brightness || props.form.effects?.contrast || props.form.effects?.gamma)

        this.state = {
            newFormat: {
                id: "new",
                project_id: null,
                width: 1080,
                height: 1080,
                name: trans('new'),
                templates: [],
            },
            oldSizeBeforeNewFormat: null,
            isLoaded: false,
            floodFillPoints: null,
            newX: null,
            newY: null,
            newFuzz: defaultFuzz,
            validateNow: false,
            backgroundType: props.form.background_type ? props.form.background_type : (props.form.gradient_id ? 'gradient' : 'color'),
            showFilters: isShowFilters,
            oldFilters: isShowFilters ? props.form.effects : { ...emptyEffects, project_id: projectId }
        }
    }

    updateFloodFeedsPointsInState = () => {
        const { form, isAlt } = this.props

        const isRemoveBackground = form.effects && form.effects.flood_fill_points
        const points: FloodFillPoint[] = isRemoveBackground && isJson(form.effects.flood_fill_points) ? JSON.parse(form.effects.flood_fill_points) : null

        this.setState({ floodFillPoints: points })
        const newFloodFillPoints = points ? JSON.stringify(points) : null

        if (form.effects && form.effects.flood_fill_points !== newFloodFillPoints) {
            this.handleUpdateEffect(newFloodFillPoints, 'flood_fill_points')
        }
    }

    componentDidMount() {
        this.updateFloodFeedsPointsInState()
        this.props.setActiveShapeId(null)
        this.props.setActiveGroupId(null)
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (prevProps) {
            const prevForm = prevProps && typeof prevProps.isAlt !== 'undefined' ? prevProps?.form : null
            const thisForm = this.props.form

            if (prevForm && prevForm.effects && thisForm.effects && prevForm.effects.flood_fill_points !== thisForm.effects.flood_fill_points) {
                this.updateFloodFeedsPointsInState()
            }

            if (
                (prevProps.randomProduct && this.props.randomProduct && prevProps.randomProduct.id !== this.props.randomProduct.id) ||
                JSON.stringify(this.props.form.effects) !== JSON.stringify(prevProps.form.effects)
            ) {
                this.handleUpdateEffect()
            }
        }
    }

    updateEffectsDebounced = debounce(() => {
        const { randomProduct, form, isAlt } = this.props

        const currentEffects = form.effects ? { ...form.effects } : { ...emptyEffects }
        const a = getSelectedAltLevels()

        console.debug('handle update effects debounced', currentEffects)
        this.props.updateEffects(randomProduct.id, currentEffects, form.is_autocrop, a?.levels, a?.mode)
    }, 200)

    handleUpdateEffect = (val: string | number | string[] = null, field: string = null): boolean => {
        const { randomProduct, form, isAlt } = this.props

        const formName = getFormName(isAlt)

        const hasPreviousValue = form.effects && typeof form.effects === 'object' && typeof form.effects[field] !== 'undefined'

        const currentEffects = form.effects ? { ...form.effects } : { ...emptyEffects }
        const previousValue = hasPreviousValue ? currentEffects[field] : emptyEffects[field]

        if (hasPreviousValue && val && field && previousValue === val) {
            console.debug('return false', val, previousValue)
            return false
        }

        let newEffects = { ...currentEffects }
        if (field) {
            newEffects[field] = val
        } else {
            newEffects = { ...emptyEffects, ...currentEffects, project_id: projectId }
        }

        this.props.change(formName, 'effects', newEffects)
        const a = getSelectedAltLevels()

        console.debug('updating effects for product', randomProduct.id)
        this.props.updateEffects(randomProduct.id, newEffects, form.is_autocrop, a?.levels, a?.mode, null, null, true)  //force
                            //updateEffects : UpdateEffectsFunctionType = (productId: ID, newEffects: EffectsType, isAutocrop: intboolean, altLevels: string[], altLevelsMode: LevelsModeType, newPublished: boolean = null, thisRandomProduct: RandomProduct = null, isForce: boolean = null) => {

        return true
    }


    handleSuperEffect = (value: AITemplatType) => {
        const { form, isAlt, randomProduct } = this.props

        const formName = getFormName(isAlt)

        const updatedForm: Template|AlternativeTemplate = {
            ...form,
            watermark_group_id: null,
            type: value,
        }

        //set is loading false:
        this.props.initForm(formName, { ...updatedForm })
        this.updateEffectsDebounced()   //update after random product is set!!!!
    }

    handleSetBackgroundType = (value: BackgroundType) => {
        const { isAlt } = this.props
        const formName = getFormName(isAlt)

        this.props.change(formName, 'background_type', value)
        this.setState({ backgroundType: value })
    }

    toggleFilters = (isShowFilters: boolean) => {
        const { form, isAlt } = this.props
        const {oldFilters} = this.state

        const formName = getFormName(isAlt)

        if (!isShowFilters) {
            const newEffects = { ...emptyEffects, project_id: projectId }
            this.props.change(formName, 'effects', newEffects)
            const a = getSelectedAltLevels()
            this.props.updateEffects(this.props.randomProduct.id, newEffects, form.is_autocrop, a?.levels, a?.mode)

            this.setState({
                showFilters: !!isShowFilters,
                oldFilters: form.effects,   //save old filters before set empty
            })
        } else {
            //pick up the old filters:
            this.props.change(formName, 'effects', oldFilters)
            const a = getSelectedAltLevels()
            this.props.updateEffects(this.props.randomProduct.id, oldFilters, form.is_autocrop, a?.levels, a?.mode)

            this.setState({
                showFilters: !!isShowFilters,
            })
        }
    }

    handleChangeGradient = (gradient: Gradient) => {
        const { form, isAlt } = this.props

        const formName = getFormName(isAlt)

        this.props.initForm(formName, {
            ...form,
            gradient: gradient,
            gradient_id: gradient?.id ? gradient.id : null,
        })
    }

    renderSetBackgroundForm = (backgroundType: BackgroundType) => {
        const { form, isAlt } = this.props

        const formName = getFormName(isAlt)

        switch (backgroundType) {
            case "gradient":
                return <SelectGradient gradientId={form.gradient_id} handleChangeGradient={this.handleChangeGradient} />
            case "color":
                return <TransparentColor
                    name={`${formName}.background`}
                    value={form.background}
                    changeGradient={(gradient: Gradient) => this.props.change(formName, 'gradient_id', gradient.id)}
                    changeValue={(color) => this.props.change(formName, 'background', color)}
                />
            case "random_colors":
                return <MultiColorSelect />
            case "random_gradients":
                return <MultiGradientSelect />
            case "dominant_color":
            case "dominant_color_2":
            case "dominant_color_3":
            default:
                return <div />
        }
    }

    getSensitivityValueWmRemove = (effectSensitivity: 'LOW' | 'MEDIUM' | 'HIGH') => {
        switch (effectSensitivity) {
            case 'LOW':
                return 2;
            case 'MEDIUM':
                return 1;
            case 'HIGH':
            default:
                return 0;
        }
    }


    renderSupereffectForm = (type: AITemplatType) => {
        const { randomProduct, watermarkGroups, inpaintingGroups, form, isAlt } = this.props

        const formName = getFormName(isAlt)

        const selectedWatermarkGroup = watermarkGroups.isLoaded && form.watermark_group_id && form.type === RENDERED_TYPE_AUTOWMREMOVE ?
            find(watermarkGroups.data, (watermarkGroup: WatermarkGroupType) => {
                return `${watermarkGroup.id}` === `${form.watermark_group_id}`
            }) : null

        const selectedInpaintingGroup = inpaintingGroups.isLoaded && form.inpainting_group_id && form.type === RENDERED_TYPE_INPAINTING ?
            find(inpaintingGroups.data, (inpaintngGroup: InpaintingGroupType) => {
                return `${inpaintngGroup.id}` === `${form.inpainting_group_id}`
            }) : null

        //const onlyPublishedGroups = watermarkGroups && watermarkGroups.isLoaded && watermarkGroups.data.length > 0 ? watermarkGroups.data.filter(g => g.published_at) : null

        switch (type) {
            case RENDERED_TYPE_BGREMOVE:
                return <Grid cols={'auto'}>
                    <GridCell>
                        <FieldLabel>{trans('effect_sensitivity')}</FieldLabel>
                    </GridCell>
                    <GridCell>
                        <div style={{ padding: '30px' }}>
                            <Slider
                                disabled={randomProduct.isLoading}
                                value={form.effect_sensitivity ? (form.effect_sensitivity === 'LOW' ? 0 : (form.effect_sensitivity === 'HIGH' ? 2 : 1)) : 1}
                                defaultValue={1}
                                step={1}
                                min={0}
                                max={2}
                                marks={[
                                    { value: 0, label: trans('LOW') },
                                    { value: 1, label: trans('MEDIUM') },
                                    { value: 2, label: trans('HIGH') },
                                ]}
                                valueLabelDisplay="off"
                                onChange={(event, value: number) => {
                                    this.props.change(formName, 'effect_sensitivity', ['LOW', 'MEDIUM', 'HIGH'][value], DO_NOT_SAVE_HISTORY)
                                }}
                            />
                        </div>
                    </GridCell>
                </Grid>
            case RENDERED_TYPE_INPAINTING:
                return <div>
                            <FieldLabel>
                                {trans('watermark_mask')}
                                {!this.props.showAsModal &&
                                <span className='clickable' onClick={() => this.props.setShowAsModal(true)}>
                                    <Icon type='open-in-new-window-radix' size={20} />
                                </span>
                            }
                        </FieldLabel>
                    {inpaintingGroups && inpaintingGroups.data && inpaintingGroups.data.length > 0 &&
                        <div style={{ margin: '20px 0' }}>
                            <InpaintingGroupSelect />
                        </div>
                    }
                </div>
            case RENDERED_TYPE_AUTOWMREMOVE:
                return <div style={{ margin: '20px 0' }}>
                    <div style={{ margin: '10px 0px' }}>
                        {watermarkGroups.data &&
                            <WatermarkGroupsSelect
                                selectedGroupId={selectedWatermarkGroup?.id}
                                setSelectedGroup={(watermarkGroupId) => {
                                    this.props.change(formName, 'watermark_group_id', parseInt(`${watermarkGroupId}`))
                                }}
                                variant={'select'}
                                maxImages={SHOW_MAX_IMAGES}
                                setShowAsModal={this.props.setShowAsModal}
                            />
                        }
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                        <Select
                            label={trans('watermark_methods')}
                            options={[
                                { label: 'YOLO', value: 'YOLO' },
                                { label: 'TEMPLATE_MATCHING', value: 'TEMPLATE_MATCHING' },
                            ]}
                            value={form.watermark_methods}
                            placeholder='default'
                            multiple={true}
                            closeOnChange={true}
                            onClear={() => this.props.change(formName, 'watermark_methods', null)}
                            onChange={(e) => this.props.change(formName, 'watermark_methods', e)}
                        />
                    </div>

                    <Grid cols={'auto'}>
                        <GridCell>
                            <FieldLabel>{trans('effect_sensitivity')}</FieldLabel>
                        </GridCell>
                        <GridCell>
                            <div style={{ padding: '30px' }}>
                                <Slider
                                    disabled={randomProduct.isLoading}
                                    value={this.getSensitivityValueWmRemove(form.effect_sensitivity || 'HIGH')}
                                    step={1}
                                    min={0}
                                    max={2}
                                    marks={[
                                        { value: 0, label: trans('HIGH') },     /* default */
                                        { value: 1, label: trans('MEDIUM') },
                                        { value: 2, label: trans('LOW') },
                                    ]}
                                    valueLabelDisplay="off"
                                    onChange={(event, value: number) => {
                                        this.props.change(formName, 'effect_sensitivity', ['HIGH', 'MEDIUM', 'LOW'][value], DO_NOT_SAVE_HISTORY)
                                    }}
                                />
                            </div>
                        </GridCell>
                    </Grid>
                </div>
            default:
                return <div />
        }
    }

    render() {
        const { settingsForm, randomProduct, form, isAlt } = this.props
        const { backgroundType, showFilters } = this.state

        const formName = getFormName(isAlt)
        const templateSize = getTemplateSize(form)

        const backgroundRGBA = hexToRgba(form.background)
        const isBackgroundTransparent = backgroundRGBA && backgroundRGBA.a < 255
        const isNotPNG = settingsForm.output_image_format !== 'png'

        const dominantColor = randomProduct?.dominantColor
        const randomProductPalette = randomProduct?.palette && Array.isArray(randomProduct.palette) && randomProduct.palette.length > 1 ? randomProduct.palette : null

        return (
            <StyledDiv className={'hide-buttons horizontal-fixed-size'}>
                <InputGroup
                    orientation="horizontal"
                    className={'input-group-v-grid'}
                    name={`${formName}.type`}       //important to get unique id for RadioInput in MUK
                    label={trans("ai_tools")}
                    onChange={this.handleSuperEffect}
                    value={form.type}
                    singleChoice={true}
                    items={[
                        { label: trans('none'), value: null },
                        { label: trans('template_type_2'), value: RENDERED_TYPE_BGREMOVE },
                        { label: trans('template_type_3') + ' (BETA)', value: RENDERED_TYPE_AUTOWMREMOVE },
                        { label: trans('template_type_1'), value: RENDERED_TYPE_UPSCALE },
                        { label: trans('template_type_4'), value: RENDERED_TYPE_OUTPAINTING, disabled: !!form.is_keep_size },
                        { label: trans('template_type_6'), value: RENDERED_TYPE_INPAINTING },
                    ]}
                />

                {!!(canBeOutpaintedOver(true, form.overscan, form.translate_x, form.translate_y) && form.type === RENDERED_TYPE_OUTPAINTING && !form.is_keep_size) &&
                    <StyledGrid cols={'1fr 1fr'} gap={'10px'}>
                        <GridCell>
                            <Toggler
                                style={{ marginTop: '20px' }}
                                onLabel={trans('outpaint_over')}
                                title={trans('outpaint_over')}
                                name={`${formName}.outpaint_over`}
                            />
                        </GridCell>
                        <GridCell>
                            {!!form.outpaint_over &&
                                <NumericInput
                                formName={formName}
                                fieldName={'overscan'}
                                placeholder={'overscan'}
                                id={'overscan'}
                                units={'px'}
                                min={(-floor(templateSize.width / 2) + 1)}
                                max={templateSize.width}
                                step={10}
                                value={-round(form.overscan)}
                                onChangeFunction={(val) => {
                                    change(formName, 'overscan', -val)
                                }}
                                />
                            }
                        </GridCell>
                    </StyledGrid>
                }

                <br />

                {form.type &&
                    this.renderSupereffectForm(form.type)
                }

                <InputGroup
                    orientation="horizontal"
                    className={'input-group-v-grid'}
                    name={`${formName}.background_type`}    //important to get unique id for RadioInput in MUK
                    label={trans("set_background")}
                    onChange={this.handleSetBackgroundType}
                    value={backgroundType}
                    singleChoice={true}
                    style={{
                        ' .m-image': {
                            border: '1px solid #e4e4e7',
                        }
                    }}
                    items={[
                        {
                            label: <span
                                onClick={() => {
                                    try {
                                        const el = document.getElementById(`color-picker-wrapper-${formName}.background`)
                                        if (el) {
                                            const input = el.querySelector<HTMLInputElement>('input');
                                            if (input) {
                                                input.click()
                                            }
                                        }
                                    } catch (e) {
                                        console.debug('cannot open colorpicker', e)
                                    }
                                }}>{`${trans('color')}`} {form.background && <Icon type="square" color={form.background} />}</span>,
                            value: "color"
                        },
                        { label: trans('gradient'), value: "gradient" },
                        { label: trans('random_colors'), value: "random_colors" },
                        { label: trans('random_gradients'), value: "random_gradients" },
                        { label: <span>{`${trans('dominant_color')}`} {dominantColor && <Icon type="square" color={dominantColor} />}</span>, value: "dominant_color" },
                        { label: <span>{`${trans('dominant_color')} 2`} {randomProductPalette && typeof randomProductPalette[0] !== 'undefined' && <Icon type="square" color={randomProductPalette[0] ?? undefined} />}</span>, value: "dominant_color_2" },
                        { label: <span>{`${trans('dominant_color')} 3`} {randomProductPalette && typeof randomProductPalette[1] !== 'undefined' && <Icon type="square" color={randomProductPalette[1] ?? undefined} />}</span>, value: "dominant_color_3" },
                    ]}
                />

                <br />

                {this.renderSetBackgroundForm(backgroundType)}

                {form.background_type === 'color' && isBackgroundTransparent && isNotPNG &&
                    <Message type={"warning"} closeable={true} icon={<Icon type={'exclamation-triangle'} color={Theme.orange} size={28} />}>
                        {trans("warn_transparent_background")} &nbsp;
                        <Link to={`/eshop/${eshopId}/project/${projectId}/settings`} target="_blank">
                            <Icon type="settings-light" color={Theme.blue} /> {trans('project_settings')}.
                        </Link>
                    </Message>
                }

                <br /><br />

                <FieldLabel>{trans('other_effects')}</FieldLabel>
                <div className="togglers">
                    <Toggler
                        onLabel={trans('filters')}
                        value={showFilters || ''}
                        onChange={this.toggleFilters}
                    />

                    {!!(showFilters && form.effects) &&
                        <Div padding="0 20px">
                            <EffectsForm handleUpdateEffect={this.handleUpdateEffect} />
                        </Div>
                    }

                    <Toggler
                        onLabel={trans('auto_level')}
                        value={form.effects?.auto_level || ''}
                        onChange={(val) => this.handleUpdateEffect(val, 'auto_level')}
                    />

                    <ProductImageReflection form={form} formName={formName} />
                    <ProductImageShadow form={form} formName={formName} props={this.props} />

                    <Toggler
                        onLabel={trans('alpha')}
                        value={!!form.alpha}
                        onChange={(val) => this.props.change(formName, 'alpha', val ? .5 : null)}
                    />

                    {!!form.alpha &&
                        <Div padding="0 20px">
                            <Range
                                label="Alpha"
                                min={0.01}
                                max={1}
                                step={.01}
                                name={`${formName}.alpha`}
                            />
                        </Div>
                    }
                </div>
            </StyledDiv>
        )
    }
}

const StyledDiv = css("div")({
    fontSize: '14px',

    ".togglers .muk-form-group": {
        marginBottom: "5px",
    },
    ' .placeholder': {
        color: iconDisabledColor,
        position: 'absolute',
        top: '10px',
        left: '10px',
        zIndex: 10,
    },
    ' .shorter': {
        ' input': {
            paddingLeft: '30px',
        },
    },
    ' .alt-image-layout': {
        fill: '#eee',
    },
    ' .shadow-box': {
        ' .alt-image-layout': {
            fill: '#cce4fb',
            stroke: '#fff',
        },
    },
    ' .date-range-form': {
        /*position: 'relative',*/
    },
    ' .date-range-form-label': {
        alignSelf: 'center',
        position: 'relative',
    },
    ' .muk-datepicker': {
        position: 'unset',
    },
    ' .muk-datepicker-popover': {
        maxWidth: '100%',
        fontSize: '9px',
        overflowX: 'auto',
    },
    ' .muk-datepicker-picker': {
        border: '1px solid #ccc',
    },
    ' #flood-fill-points': {
        maxWidth: '100%',
        maxHeight: '200px',
        width: 'auto',
        height: 'auto',
        boxShadow: '0 0 3px 1px rgba(0,0,0,.3)',
        webkitBoxShadow: '0 0 3px 1px rgba(0,0,0,.3)',
        mozBoxShadow: '0 0 3px 1px rgba(0,0,0,.3)',
    },
    ' .input-group-v-grid .muk-grid': {
        gridTemplateColumns: '1fr 1fr',
        gridAutoFlow: 'dense',
    },
    '@media screen and (max-width: 800px)': {
        ' .input-group-v-grid .muk-grid': {
            gridAutoFlow: 'dense',
        },
    },

    ".items .muk-radio.m-item": {
        minHeight: "54px",
    }
})

const StyledGrid = css(Grid)({
    marginTop: '20px',
    ' .muk-gridcell': {
        alignSelf: 'center',
    }
})

function mapStateToProps(state) {
    return {
        randomProduct: state.randomProduct,
        watermarkGroups: state.watermarkGroups,
        inpaintingGroups: state.inpaintingGroups,
        userId: state.project.data.user?.id,
        isAlt: state.isAlt,
        form: selectFormValues(state, getFormName(state.isAlt)),
        collageLayoutsForm: selectFormValues(state, 'collageLayoutsForm'),
        settingsForm: selectFormValues(state, 'settingsForm'),
    }
}

export default connect(mapStateToProps, {
    change,
    initForm,
    createToast,
    setActiveShapeId,
    setActiveGroupId,
    setActiveView,
})(EditEffects)